<app-authentication-login [hidden]="isBypass || isClientSessionCloseWindow" [ngClass]="{'refreshing': isBypass }" [msgs]="msgs" [submitting]="submitting$ | async"
        (forgotPasswordClicked)="onForgetPassword($event)" (signinClicked)='onSignin($event)'>
</app-authentication-login>

<ng-container *ngIf="isClientSessionCloseWindow">
        <h2 class="client-session-close-window-msg">{{'ARC_COMPOSITE_CLIENT_SESSION_CLOSE_WINDOW' | translate}}</h2>
</ng-container>